module.exports = __webpack_public_path__ + "static/img/empty.27c4607.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/empty.png
// module id = vTAX
// module chunks = 56